import searchSetup from 'Api/Algolia/algolia-setup';
import { topSellerIndex } from 'Api/Algolia/algolia-calls';
import fixedResults from 'Api/Algolia/auto-search-fixed-results';

let combinedFixedResults = fixedResults;

const formatFacet = facet => ({
  key: facet.name.toLowerCase().replace(/-/g, ' ').replace(/[^a-zA-Z0-9 ]/g, ''),
  path: `${facet.facet.replace('combo', 'combo-collections')}/${facet.slug}`,
  name: facet.name,
  facetName: facet.name,
  cover: facet.cover_image || `facet/${facet.facet}/${facet.slug}`,
  count: facet.count,
  isFacet: true,
});

// Match the start of the word from the list above to the search string
const partialMatchFixed = (string) => {
  const regex = new RegExp(`^${string.replace(/-/g, ' ').replace(/[^a-zA-Z0-9 ]/g, '').replace(/s$/, '')}s?`, 'i');
  return combinedFixedResults.filter(result => regex.test(result.key));
};

const searchCache = {};

export default async function fetchAutoSearch(searchString, hitsPerPage = 5, filters = '', allFacets = []) {
  const query = (searchString ? searchString.replace(/[^\w\s]/gi, ' ') : '').trim();

  const cacheKey = `${filters}|${hitsPerPage}|${allFacets.length}|${query}`;

  if (searchCache[cacheKey]) {
    return searchCache[cacheKey];
  }

  if (combinedFixedResults.length !== (allFacets.length + fixedResults.length)) {
    combinedFixedResults = [...fixedResults, ...allFacets.map(formatFacet)];
  }

  const index = await searchSetup(topSellerIndex());
  return index.search(query, {
    hitsPerPage,
    filters,
    analyticsTags: ['userSearch', 'autoSearch'],
  }).then((autoSearchResults) => {
    const results = Object.assign({}, autoSearchResults);
    const fixedMatches = partialMatchFixed(searchString);

    if (fixedMatches.length) {
      results.hits = [
        ...autoSearchResults.hits,
        ...fixedMatches.slice(0, 3),
      ];

      results.nbHits = fixedMatches.length + autoSearchResults.nbHits;
    }

    searchCache[cacheKey] = results;

    return results;
  });
}
